<template>
  <div class="terms-condition">
    <dialog-banner @callback-submit="onCallbackSubmit">
      <span slot="content">
        การใช้งาน FINNOMENA MONEY แสดงว่าคุณได้ยอมรับ
        <a
          href="javascript:;"
          @click="openWindow('https://www.finnomena.com/terms?webview=line&bt_id=71')"
          class="terms-condition__link"
          data-action="terms"
          data-location="cookie_banner"
        >ข้อตกลงและเงื่อนไขการใช้งาน</a>
        และ
        <a
          href="javascript:;"
          @click="openWindow('https://www.finnomena.com/privacy-policy?webview=line&bt_id=71')"
          class="terms-condition__link"
          data-action="privacy_policy"
          data-location="cookie_banner"
        >นโยบายความเป็นส่วนตัว</a>
        ของ FINNOMENA
      </span>
    </dialog-banner>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { DialogBanner } from "../../molecules"
export default {
  components: {
    DialogBanner
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters("auth", ["getIslogin"]),
    ...mapGetters("onboarding", ["getPDPA"])
  },
  methods: {
    ...mapActions("onboarding", ["fetchConfiguration", "insertConfiguration"]),
    ...mapActions("pdpa", ["fetchTermsAndCondition", "updateTermsAndCondition"]),
    async onCallbackSubmit(obj) {
      const { val } = obj
      if (val) {
        this.getPDPA.termsandcondition = val
        const res = await this.insertConfiguration() // upsert data
        res ? this.fetchConfiguration() : null
        if (this.getIslogin) {
          // check terms condition status if user aleardy login
          const status = await this.fetchTermsAndCondition()
          if (status != val) {
            // update from state to fnds setting
            await this.updateTermsAndCondition({
              status: val
            })
          }
        }
      }
    },
    openWindow(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_DialogTermsAndCondition";
</style>